"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
var _LockOutlined = _interopRequireDefault(require("@material-ui/icons/LockOutlined"));
var _react = _interopRequireDefault(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../config");
var _Link2 = require("react-platform-components/dist/Link/Link");
var _reactRedux = require("react-redux");
var _LanguageSwitcherForForms = require("../LanguageSwitcher/LanguageSwitcherForForms");
var _excluded = ["setSubmitting"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  return {
    '@global': {
      body: {
        backgroundColor: theme.palette.common.white
      }
    },
    paper: {
      marginTop: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main
    },
    form: {
      width: '100%',
      // Fix IE 11 issue.
      marginTop: theme.spacing(3)
    },
    submit: {
      margin: theme.spacing(3, 0, 2)
    },
    container: {
      padding: '5px 25px',
      boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      marginTop: '25px'
    }
  };
};
var BaseRegisterContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseRegisterContainer, _React$Component);
  var _super = _createSuper(BaseRegisterContainer);
  function BaseRegisterContainer() {
    var _this;
    _classCallCheck(this, BaseRegisterContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values, _ref) {
      var setSubmitting = _ref.setSubmitting,
        props = _objectWithoutProperties(_ref, _excluded);
      _this.props.dispatch({
        type: 'REGISTER_USER',
        data: _objectSpread(_objectSpread({}, values), {}, {
          email: values.email.trim().toLowerCase()
        }),
        history: _this.props.history
      });
    });
    return _this;
  }
  _createClass(BaseRegisterContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Check if a componentDidMount function is provided and excute it
      // we pass it the props so the function can use them to dispatch the actions
      if (this.props.componentDidMount) {
        this.props.componentDidMount.bind(this)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        icon = _this$props.icon,
        handleSubmit = _this$props.handleSubmit;
      var Form = this.props.form;
      return /*#__PURE__*/_react.default.createElement(_Container.default, {
        component: "main",
        maxWidth: "sm",
        className: classes.container
      }, /*#__PURE__*/_react.default.createElement(_CssBaseline.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: classes.paper
      }, _config.LOGO_PATH && _config.LOGO_LINK && _config.LOGO_LINK_URL ? /*#__PURE__*/_react.default.createElement(_Link2.Link, {
        to: _config.LOGO_LINK_URL,
        base: _config.BASE_URL
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _config.LOGO_PATH,
        alt: "Logo",
        width: "220"
      })) : _config.LOGO_PATH && _config.LOGO_LINK ? /*#__PURE__*/_react.default.createElement(_Link2.Link, {
        to: "",
        base: _config.BASE_URL
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _config.LOGO_PATH,
        alt: "Logo",
        width: "220"
      })) : /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: this.props.locale.locale === _config.DEFAULT_LOCALE ? "/" : "/".concat(this.props.locale.locale)
      }, _config.NAVBAR_LOGO_PATH ? /*#__PURE__*/_react.default.createElement("img", {
        src: _config.NAVBAR_LOGO_PATH,
        alt: "",
        width: "180"
      }) : /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        className: classes.avatar
      }, /*#__PURE__*/_react.default.createElement(_LockOutlined.default, null))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "h1",
        variant: "h5",
        style: {
          marginTop: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: title ? title : "Sign up"
      })), /*#__PURE__*/_react.default.createElement(Form, _extends({
        handleSubmit: handleSubmit ? handleSubmit : this.handleSubmit
      }, this.props))), /*#__PURE__*/_react.default.createElement(_Box.default, {
        mt: 5
      }), /*#__PURE__*/_react.default.createElement(_LanguageSwitcherForForms.LanguageSwitcher, null));
    }
  }]);
  return BaseRegisterContainer;
}(_react.default.Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    locale: state.localeReducer
  };
};
//export default withStyles(styles)connect(mapStateToProps)(BaseRegisterContainer)
var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _styles.withStyles)(styles)(BaseRegisterContainer));
exports.default = _default;